import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import t from "../../../i18n/i18n";
import useApi from "../../../services/api";
import { handleApiErrors } from "../../../utils/handleErrors";

import Membership from "../../../components/membership/membership";

function UserInfo() {
  const { user } = useSelector((store) => store.auth);
  const { name, nickname, avatar, credits, loyal_member_points } = user;

  const { ApiGetLoyalMember } = useApi();

  const [loyalMember, setLoyalMemer] = useState(null);

  async function getLoyalMember() {
    const { data } = await ApiGetLoyalMember();
    if (data.errors) {
      return handleApiErrors(data.errors);
    }

    data.sort((a, b) => {
      if (a.target_points < b.target_points) return -1;
      if (a.target_points > b.target_points) return 1;
      return 0;
    });

    for (let i = 0; i < data.length; i++) {
      if (
        loyal_member_points >= data[i].target_points &&
        (data[i + 1] ? loyal_member_points < data[i + 1].target_points : true)
      ) {
        setLoyalMemer({ ...data[i] });
      }
    }
  }

  function classColor() {
    switch (loyalMember.name) {
      case "Silver":
        return "color-gold";
      case "Gold":
        return "color-lblue";
      case "Platinum":
        return "color-lmengata";
      default:
        return "color-lmengata";
    }
  }

  useEffect(() => {
    getLoyalMember();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loyalMember && (
        <>
          <div className="profile-box gutter-40">
            <div className="user-name-info">
              <span className="user-thumb">
                <img src={avatar || "/images/user-thumn-m.png"} alt="" />
              </span>
              <div className="user-name-title">
                {nickname && <span className="name">{nickname}</span>}
                <small>@{name}</small>
              </div>
            </div>
          </div>
          <div className="user-credit-box gutter-40">
            <div className="credit-data">
              <span className="icon">
                <img src="images/credit-ico.png" alt="" />
              </span>
              {t("General.YouHave")} <h6>{credits || 0}</h6>
              <small>{t("General.Credits")}</small>
            </div>
          </div>
          <div className="membership-box gutter-40 black">
            <Membership user={user} />
          </div>
          <div className="loyal-pont gutter-40">
            <div className="loyal-pont-col">
              <h5>
                {t("LoyalMember.MyPoints")} <span className={classColor()}>{loyal_member_points}</span>
              </h5>
              <h5>
                {t("LoyalMember.GrowthRate")}{" "}
                <span className={classColor()}>
                  {loyalMember.growth_rate} {t("LoyalMember.PointsDay")}
                </span>
              </h5>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default UserInfo;
